'use client';
import React, { useState } from "react";
import ReactDatePicker, { DatePickerProps } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "../styles/Input.module.css";
import Icon from "../../Icon/Icon";

interface Props extends Omit<DatePickerProps, "selected" | "onBlur" | "onChange" | "value"> {
    id: string;
    label?: string;
    value?: Date | null;
    onBlur?: (date: Date | null) => void;
    classOverrides?: string;
    onChange?: (date: Date | null) => void;
}

const DatePicker: React.FC<Props> = ({ id, label, value, onBlur, classOverrides = '', onChange, ...restProps }) => {
    const [selectedDate, setSelectedDate] = useState<Date | null>(value ? new Date(value) : null);

    const handleChange = (date: Date | null) => {
        setSelectedDate(date);
        if (onChange) {
            onChange(date)
        }
    };

    const handleBlur = () => {
        if (onBlur) {
            onBlur(selectedDate);
        }
    };

    return (
        <label
            htmlFor={id}
            className={`${styles.inputLabel} flex gap-100 items-center relative justify-end sm:justify-normal ${classOverrides}`}
        >
            {!!label && <span>{label}</span>}
            <div className={`${styles.inputWrap} !w-[8.5rem]`}>
                {/* TODO: Fix this */}
                {/* @ts-ignore */}
                <ReactDatePicker
                    id={id}
                    className={styles.input}
                    selected={selectedDate}
                    onChange={handleChange}
                    onCalendarClose={handleBlur}
                    dateFormat="dd-MM-yyyy"
                    {...restProps}
                />

                <Icon icon="calendar" className={`${styles.inputIcon} pointer-events-none`} />
            </div>
        </label>
    );
};
export default DatePicker;
